import { createContext, useContext } from 'react'
import type { ReactNode } from 'react'
import { useLocationDetailQuery } from '../hooks/useLocationDetailQuery'
import type { LocationDetail } from '../../../types/location'

interface LocationDetailContextValue {
  location: LocationDetail | null
  isLoading: boolean
  error: Error | null
}

const LocationDetailContext = createContext<LocationDetailContextValue>({
  location: null,
  isLoading: false,
  error: null,
})

interface LocationDetailProviderProps {
  storeId: string
  warehouseId: string
  children: ReactNode
}

export const LocationDetailProvider = ({ storeId, warehouseId, children }: LocationDetailProviderProps) => {
  const { data: location = null, isLoading, error } = useLocationDetailQuery(storeId, warehouseId)

  return (
    <LocationDetailContext.Provider value={{ location, isLoading, error: error as Error | null }}>
      {children}
    </LocationDetailContext.Provider>
  )
}

export const useLocationDetail = (): LocationDetailContextValue => useContext(LocationDetailContext)
